import { render, staticRenderFns } from "./FoodDetailLayerCart.vue?vue&type=template&id=a72ab3b4&scoped=true&"
import script from "./FoodDetailLayerCart.vue?vue&type=script&lang=js&"
export * from "./FoodDetailLayerCart.vue?vue&type=script&lang=js&"
import style0 from "./FoodDetailLayerCart.vue?vue&type=style&index=0&id=a72ab3b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a72ab3b4",
  null
  
)

export default component.exports